import * as React from "react";
import { cn } from "../../lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full min-w-0 rounded-lg border border-input bg-card px-3.5 py-2 text-[15px] md:text-sm text-foreground shadow-xs",
        "placeholder:text-text-tertiary selection:bg-primary/20",
        "file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "transition-[border-color,box-shadow,background-color] duration-(--dur-fast) ease-(--ease-standard) outline-none",
        "hover:border-[color-mix(in_oklch,var(--input)_60%,var(--foreground))]",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        "disabled:pointer-events-none disabled:opacity-50 disabled:bg-muted",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
